import React from 'react';
import Link from 'gatsby-link';
import logo from '../images/logo.svg';

const Logo = () => (
  <img src={logo} alt="Logo" />
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js